import React from 'react'
import { PlanRow } from 'containers/Plan/Row/index.js'
import { View } from 'components/View.js'
import { defineMessages } from 'react-intl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { existsByIdPlanSelector } from 'pages/Plans/selectors/exists-by-id/index.js'
import TextBodySmaller from 'components/TextBodySmaller.js'
import { hasPremiumUserSelect } from 'modules/training/modules/training-users/selectors/has-premium/index.js'

const messages = defineMessages({
  partOf: {
    id: 'WorkoutPlanRow.partOf',
    defaultMessage: 'This workout is part of this plan:'
  },
  youNeedToStartThisPlan: {
    id: 'WorkoutPlanRow.youNeedToStartThisPlan',
    defaultMessage: 'To edit or start this workout, you need to start this plan:'
  }
})

/**
 * @param planId
 * @param isRecommended
 * @returns {JSX.Element}
 * @constructor
 */
export function WorkoutPlanRow ({
  planId,
  isRecommended
}) {
  const intl = useIntl()
  const exists = useSelector(existsByIdPlanSelector(planId))
  const hasPremium = useSelector(hasPremiumUserSelect)

  const message = hasPremium && isRecommended
    ? messages.youNeedToStartThisPlan
    : messages.partOf

  return (
    <View mt>
      {
        !!exists && (
          <View mb>
            <TextBodySmaller>
              {formatMessageIntlUtil(intl, message)}
            </TextBodySmaller>
          </View>
        )
      }

      <PlanRow
        id={planId}
        isRecommended={isRecommended}
      />
    </View>
  )
}
